module.exports = __webpack_public_path__ + "static/media/odnoklassniki.11333414.svg";